import { HelpersService } from './helpers.service';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable, of } from 'rxjs';
import { switchMap, first, shareReplay } from 'rxjs/operators';
import { Equipe } from '../models/equipe.model';
import { AvaliacaoList } from '../models/avaliacao.model';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  constructor(private afs: AngularFirestore, private helper: HelpersService) { }

  async buscarHackathonPorCodigoAcesso(codigoAcessoHackathon: string) {
    return this.afs.collection('/hackathon', ref => ref
      .where('codigoAcesso', '==', codigoAcessoHackathon)
      .where('ativo', '==', true))
      .valueChanges().pipe(shareReplay(1));
  }

  async getHackathon(id: string) {
    return this.afs.collection('/hackathon', ref => ref
      .where('id', '==', id))
      .valueChanges().pipe(shareReplay(1));
  }

  async getInscricoes(hackathonId: string) {
    return this.afs.collection(`/inscricao/${hackathonId}`)
      .valueChanges().pipe(shareReplay(1));
  }

  // updateInscricoes(inscricoes) {
  //   // Captura Referencia do documento no firestore
  //   const EmpresaRef: AngularFirestoreDocument<Empresa> = this.afs
  //     .doc(`empresas/${empresaData.idEmpresa}`);

  //   // Atualiza a base, mas so atualiza os dados fazendo um merge com os alterados
  //   return EmpresaRef.set(inscricoes, {merge: true});
  // }

  async getAvaliacoes(hackathonId: string) {
    return this.afs.collection('/avaliacao', ref => ref
      .where('hackathonId', '==', hackathonId))
      .valueChanges().pipe(shareReplay(1));
  }

  async getAvaliacao(hackathonId: string, uidAvaliador: string) {
    return this.afs.collection('/avaliacao', ref => ref
      .where('hackathonId', '==', hackathonId)
      .where('uidAvaliador', '==', uidAvaliador))
      .valueChanges().pipe(shareReplay(1));
  }

  updateAvaliacao(avaliacao: AvaliacaoList) {
    // Atualiza a base, mas so atualiza os dados fazendo um merge com os alterados
    // return this.afs.doc(`avaliacao/${avaliacao.uidAvaliador}`).update(avaliacao);

    // Captura Referencia do documento no firestore
    const AvaliacaoRef: AngularFirestoreDocument<AvaliacaoList> = this.afs
      .doc(`avaliacao/${avaliacao.uidAvaliador}`);

    // Atualiza a base, mas so atualiza os dados fazendo um merge com os alterados
    return AvaliacaoRef.set(avaliacao, {merge: true});
  }


  async getEquipe(equipeId: string) {
    return this.afs.collection('/equipe', ref => ref
      .where('equipeId', '==', equipeId))
      .valueChanges().pipe(shareReplay(1));
  }

  async getEquipes(hackathonId: string) {
    return this.afs.collection('/equipe', ref => ref
      .where('hackathonId', '==', hackathonId))
      .valueChanges().pipe(shareReplay(1));
  }

  updateEquipe(equipe: Equipe) {
    // Atualiza a base, mas so atualiza os dados fazendo um merge com os alterados
    return this.afs.doc(`equipe/${equipe.equipeId}`).update(equipe);
  }

  setEquipe(equipe: Equipe) {
    this.afs.collection('equipe').add(equipe)
    .then(data => {
      equipe.equipeId = data.id;
      this.helper.routeToResumoEquipe(equipe.equipeId);
      this.updateEquipe(equipe);
    });
  }
}
